<template>
  <v-main>
    <v-container fluid>
      <v-btn
        fab
        x-small
        class="mx-2 mb-2"
        color="white"
        @click="$router.back()"
      >
        <v-icon light> mdi-arrow-left </v-icon>
      </v-btn>
      <v-card elevation="10" align="center" class="mt-4" rounded="xl">
        <v-row class="mx-4 mt-2">
          <v-col class="pa-0 mt-2">
            <h5 class="text-h6" align="left">Date</h5>
            <v-col class="pa-0 pt-4">
              <v-dialog
                ref="ApplicationDae"
                :close-on-content-click="false"
                v-model="date_of_application_menu"
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    readonly
                    solo
                    dense
                    rounded
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  scrollable
                  @input="date_of_application_menu = false"
                >
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-col>
        </v-row>

        <v-row class="mx-4 my-2">
          <v-col class="pa-0">
            <h5 class="text-h6" align="left">Days</h5>
            <v-select
              solo
              hide-details=""
              dense
              rounded
              v-model="form.day"
              :items="days"
              label="Days"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="mx-4 my-2">
          <v-col class="pa-0">
            <h5 class="text-h6" align="left">Visit Status</h5>
            <v-select
              solo
              hide-details=""
              dense
              rounded
              v-model="form.visit_status"
              :items="visit_statuses"
              label="Visit Status"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="mx-4 my-2">
          <v-col class="pa-0">
            <h5 class="text-h6" align="left">Daily Agenda</h5>
            <v-select
              solo
              hide-details=""
              dense
              rounded
              v-model="form.visited_site_id"
              :items="sites"
              label="Sites"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="mx-4 mt-2 my-2">
          <v-col class="pa-0">
            <h5 class="text-h6" align="left">Daily Work</h5>
            <v-textarea
              hide-details=""
              solo
              dense
              rounded
              v-model="form.daily_work"
              placeholder="Daily Work"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row class="mx-4 mt-2 my-2">
          <v-col class="pa-0">
            <h5 class="text-h6" align="left">Time Duration</h5>
            <v-row>
              <v-col class="pa-0 pt-4 mx-2">
                <v-dialog
                  ref="fromTimeDialog"
                  :close-on-content-click="false"
                  v-model="from_time_menu"
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.from_time"
                      label="From Time"
                      readonly
                      solo
                      dense
                      rounded
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="form.from_time"
                    format="ampm"
                    scrollable
                    @input="from_time_menu = false"
                  ></v-time-picker>
                </v-dialog>
              </v-col>
              <v-col class="pa-0 pt-4 mx-2">
                <v-dialog
                  ref="toTimeDialog"
                  :close-on-content-click="false"
                  v-model="to_time_menu"
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.out_time"
                      label="To Time"
                      readonly
                      solo
                      dense
                      rounded
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="form.out_time"
                    format="ampm"
                    scrollable
                    @input="(to_time_menu = false), calculateTimeDifference()"
                  ></v-time-picker>
                </v-dialog>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mx-4 mt-2 my-2">
          <v-col class="pa-0">
            <h5 class="text-h6" align="left">Duration</h5>
            <!-- {{ days }} -->
            <v-text-field
              hide-details=""
              solo
              dense
              readonly
              rounded
              v-model="form.total_no_of_hours"
              placeholder="Duration"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mx-4 my-2">
          <v-col class="pa-0">
            <h5 class="text-h6" align="left">Status</h5>
            <v-select
              solo
              hide-details=""
              dense
              rounded
              v-model="form.status"
              :items="statuses"
              label="Status"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="mx-4 mt-2 my-2">
          <v-col class="pa-0">
            <h5 class="text-h6" align="left">Remark</h5>
            <v-textarea
              hide-details=""
              solo
              dense
              rounded
              v-model="form.remark"
              placeholder="Remark"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row class="mx-4 mt-2 my-2">
          <v-col class="pa-0">
            <h5 class="text-h6" align="left">Client Remark</h5>
            <v-textarea
              hide-details=""
              solo
              dense
              rounded
              v-model="form.client_remark"
              placeholder="Client Remark"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>

        <!-- Add Voice Recording Section before Signature -->
        <!-- <v-row class="mx-4 mt-2 my-2">
          <v-col class="pa-0">
            <h5 class="text-h6" align="left">Voice Message (Optional)</h5>
            <v-row class="mt-2">
              <v-col>
                <v-btn
                  v-if="!isRecording"
                  color="red"
                  rounded
                  @click="startRecording"
                  :disabled="audioBlob !== null"
                >
                  <v-icon left>mdi-microphone</v-icon>
                  Start Recording
                </v-btn>
                <v-btn v-else color="red" rounded @click="stopRecording">
                  <v-icon left>mdi-stop</v-icon>
                  Stop Recording
                </v-btn>
              </v-col>
              <v-col v-if="audioBlob">
                <audio controls :src="audioURL" class="mt-2"></audio>
                <v-btn small color="error" class="ml-2" @click="clearRecording">
                  Clear
                </v-btn>
              </v-col>
            </v-row>
            <p class="caption mt-2">Maximum 2 minutes recording allowed</p>
          </v-col>
        </v-row> -->

        <v-row class="mx-4 mt-6 my-2 pb-6">
          <v-col align="center" class="pa-0">
            <!-- :loading="isLoading" -->
            <!-- @click="login" -->
            <v-btn
              min-width="250"
              color="blue"
              rounded
              max-width="100"
              dark
              @click="save"
              >Submit</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-container class="footer-text">
      <v-row justify="center">
        <v-col align="center">
          <h3 class="white--text">We Alliance Sparkle</h3>
          <h4 class="white--text">v 1.0.0</h4>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      total_no_of_hours: 0,
      date_of_application_menu: false,
      from_date_menu: false,
      from_time_menu: false,
      to_date_menu: false,
      to_time_menu: false,
      isLoading: false,
      isRecording: false,
      mediaRecorder: null,
      audioChunks: [],
      sites: [],
      days: [],
      visit_statuses: [],
      statuses: [],
      audioBlob: null,
      audioURL: null,
      form: {
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        from_time: "",
        out_time: "",
        client_remark: "",
        remark: "",
      },
    };
  },

  mounted() {
    this.getMasters();
  },

  methods: {
    calculateTimeDifference() {
      if (this.form.from_time && this.form.out_time) {
        const from = moment(this.form.from_time, "hh:mm A");
        const to = moment(this.form.out_time, "hh:mm A");
        this.hours = to.diff(from, "hours", true);
        if (this.hours < 0) {
          this.hours += 24; // Handle cases where to_time is on the next day
        }
      } else {
        this.hours = null;
      }
      this.form.total_no_of_hours = this.hours;
    },

    async startRecording() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        this.mediaRecorder = new MediaRecorder(stream);
        this.audioChunks = [];

        this.mediaRecorder.ondataavailable = (event) => {
          this.audioChunks.push(event.data);
        };

        this.mediaRecorder.onstop = () => {
          this.audioBlob = new Blob(this.audioChunks, { type: "audio/webm" });
          this.audioURL = URL.createObjectURL(this.audioBlob);
          stream.getTracks().forEach((track) => track.stop());
        };

        this.mediaRecorder.start();
        this.isRecording = true;

        // Auto-stop after 2 minutes (120000 ms)
        setTimeout(() => {
          if (this.isRecording) {
            this.stopRecording();
          }
        }, 120000);
      } catch (error) {
        console.error("Error starting recording:", error);
        this.isRecording = false;
      }
    },

    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
      }
    },

    clearRecording() {
      this.audioBlob = null;
      this.audioURL = null;
      this.audioChunks = [];
    },

    async getMasters() {
      let masters = await axios.get("/pjps/masters");
      masters = masters.data.data;
      masters.sites.forEach((site) => {
        this.sites.push({
          id: site.id,
          text: site.name,
          value: site.id,
        });
      });
      masters.days.forEach((day) => {
        this.days.push({
          id: day,
          text: day,
          value: day,
        });
      });
      masters.visit_statuses.forEach((vs) => {
        this.visit_statuses.push({
          id: vs.id,
          text: vs.name,
          value: vs.id,
        });
      });
      masters.statuses.forEach((status) => {
        this.statuses.push({
          id: status.id,
          text: status.name,
          value: status.id,
        });
      });
    },

    async save() {
      try {
        this.isLoading = true;
        this.form.user_id = this.user.id;
        this.form.duration = this.form.total_no_of_hours;
        console.log(this.form);

        let pjp = await axios.post("/pjps", this.form);
        this.pjp = pjp.data.data;

        // Handle both signature and audio uploads
        // await Promise.all([this.handleFileUpload(), this.handleAudioUpload()]);

        this.isLoading = false;
        this.$router.push("/pjps");
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },

    async handleFileUpload() {
      try {
        this.isLoading = true;
        let attachment = this.$refs.signature_path?.files[0];
        if (!attachment) return;

        const leaveId = this.leave.id;
        let formData = new FormData();
        formData.append("id", leaveId);
        formData.append("signature_path", attachment);

        await axios.post("upload_leave_application_request_image", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } catch (e) {
        console.log("Signature upload failed:", e);
      } finally {
        this.isLoading = false;
      }
    },

    async handleAudioUpload() {
      try {
        if (!this.audioBlob) return;

        this.isLoading = true;
        const leaveId = this.leave.id;
        let formData = new FormData();
        formData.append("id", leaveId);
        formData.append(
          "voice_message",
          this.audioBlob,
          `voice_message_${leaveId}.webm`
        );

        await axios.post("upload_leave_application_audio", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } catch (e) {
        console.log("Audio upload failed:", e);
      } finally {
        this.isLoading = false;
      }
    },
  },

  beforeDestroy() {
    if (this.audioURL) {
      URL.revokeObjectURL(this.audioURL);
    }
    if (this.mediaRecorder && this.isRecording) {
      this.stopRecording();
    }
  },
};
</script>
